module.exports = ".alert {\n  color: red; }\n\n.alert i {\n  font-size: 8em; }\n"